import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import {
  getAuthenticatedSelector,
  getConfirmAuddlySignUpLink,
} from 'app/store/Auth/selectors';
import { useAppSelector } from 'app/store';
import { routes } from 'app/routing/routesConfig';
import {
  ChakraAuthContentWrapper,
  ChakraScrollableContainer,
} from 'app/components/Core';
import { AuddlySignUpForm } from 'app/components/AuddlySignUp';

export const AuddlySignUp: React.FC = () => {
  const signUpLink = useAppSelector(getConfirmAuddlySignUpLink)?.href;
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);
  const { state: locationState, pathname, search } = useLocation();
  const navigate = useNavigate();
  const redirectPath = (locationState as any)?.from || routes.songs.path;

  useEffect(() => {
    if (isAuthenticated) {
      return;
    }
    if (
      !pathname.includes(routes.auddlySignUpPassword.path) ||
      !pathname.includes(routes.auddlySignUpLocation.path)
    ) {
      navigate(
        { pathname: routes.auddlySignUpPassword.path, search },
        { replace: true }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isAuthenticated) {
    return <Navigate to={redirectPath} />;
  }

  return (
    <ChakraScrollableContainer m={0} px={0} maxWidth="full">
      <ChakraAuthContentWrapper
        maxWidth="full"
        centeredContainerProps={{ height: 'auto', py: 4, px: 0 }}
      >
        <AuddlySignUpForm
          signUpLink={signUpLink}
          afterSubmit={() => {
            navigate({
              pathname: routes.auth.path,
            });
          }}
        />
      </ChakraAuthContentWrapper>
    </ChakraScrollableContainer>
  );
};
